import {
    FAQ_FIND_STATE,
    FAQ_INITIAL_STATE
} from "./type";

const initiate = {
    categories: [],
    faqs: [],
    search: "",
    selectedCategoryFaqs: [],
    detail: null
}

const FaqReducer = (state = initiate, action) => {
    switch (action.type) {
        case FAQ_INITIAL_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case FAQ_FIND_STATE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}

export default FaqReducer;